import { marker } from "@jsverse/transloco-keys-manager/marker";
import { getPhoneNumber, getPrefixPhone } from "./phone";
import { sntInfo } from "src/app/common/dialog";
import { sntTranslate } from "src/app/support/translate";
import { BootstrapService } from "../modules/bootstrap/bootstrap.service";

function getWhatsappUri(
  phone: string,
  body: string,
  bootstrapService: BootstrapService
): string {
  const phoneNumber = `${getPrefixPhone(
    phone,
    bootstrapService
  )}${getPhoneNumber(phone, bootstrapService)}`;

  const url = new URL("whatsapp://send/");

  url.searchParams.set("phone", phoneNumber);
  url.searchParams.set("text", body);
  url.searchParams.set("type", "phone_number");
  url.searchParams.set("app_absent", "0");

  return url.toString();
}

export async function openWhatsapp(
  phone: string,
  text: string,
  bootstrapService: BootstrapService
): Promise<void> {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes("win")) {
    await sntInfo(
      sntTranslate(marker("Attenzione")),
      sntTranslate(
        marker(
          "Abbiamo copiato il messaggio negli appunti, ora puoi incollarlo su whatsapp"
        )
      ),
      {
        confirmText: sntTranslate(marker("Continua"))
      }
    );

    await navigator.clipboard.writeText(text);
  }

  window.open(getWhatsappUri(phone, text, bootstrapService));
  return Promise.resolve();
}
